<div class="json-view" *ngFor="let item of jsonOutput" xmlns="http://www.w3.org/1999/html">
  <div *ngIf="item.label != 'object-break'">
    <span class="json-key">{{ item.label }}</span>:
    <span class="json-val">{{ item.text }}</span>
  </div>
  <div *ngIf="item.label == 'object-break'">&nbsp;</div>
</div>
